export const employeeTimeFormat = 'HH:mm';
export const employeeDateFormat = 'DD/MM/YYYY';
export const employeeDateTimeFormat = employeeDateFormat + ' ' + employeeTimeFormat + ':ss';
